import { DropdownOptionResponse, settingsApi } from "@/api";
import { QueryKey } from "@/query/Query";

// Moved to @shared (used by the shared client-file areas in both apps); re-exported here so
// existing internal imports keep working. Only the admin-page helpers below stay internal — they
// use this app's api singleton directly.
export { dropdownQueryKey, useDropdownOptions } from "@shared";
export type { DropdownOptions } from "@shared";

export function fetchAllDropdownOptions(): Promise<DropdownOptionResponse[]> {
  return settingsApi.getAllDropdownOptions();
}

export const dropdownAdminQueryKey = [QueryKey.DropdownOptions, "admin"];
